module.exports = __webpack_public_path__ + "static/img/newsPic2.b71d2a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsPic2.png
// module id = Wvoo
// module chunks = 1